import { useState,useEffect } from 'react';
import {FolderViewOutlined,EyeOutlined} from '@ant-design/icons';
import { Card, Skeleton,Tooltip } from 'antd';
import { NavLink } from "react-router-dom";
import axios from 'axios';

const { Meta } = Card;


const Departments = () => {

    const [loading, setLoading] = useState(true);
    // const [open, setOpen] = useState(false);
    const [departmentData, setDepartmentData] = useState();
    const [userRole, setUserRole] = useState();
    const [userDept,setUserDept] = useState([])
    const [error,setError] = useState();

    
    useEffect(()=>{
      const userString = sessionStorage.getItem("user");
      const value = JSON.parse(userString);
     
     if(!userString){
        return null
     }else{
      const userUuid = value.uuid
      setUserRole(value.role)
     
      const getApi = async()=>{
        let userDep;
        await axios
        .get(`${process.env.REACT_APP_API_URL}/users/${userUuid}`)
        .then(response => {
         userDep = response.data.department
        })
        .catch(error => {
          console.error(error.response.data.msg);
          // message.error(error.response.data.msg);
          setError(error.response.data.msg);
          setTimeout(function() {
            setError();
          }, 3000);
        });

       await axios
        .post(`${process.env.REACT_APP_API_URL}/user_dept`,{userDeptUuid:userDep})
        .then(response => {
         setUserDept(response.data)
        })
        .catch(error => {
          console.error(error.response.data.msg);
          // message.error(error.response.data.msg);
          setError(error.response.data.msg);
          setTimeout(function() {
            setError();
          }, 3000);
        });
      }
      getApi()
     }
  
  },[])
    useEffect(() => {
      fetchMenuData()
    }, []); // Empty dependency array ensures the effect runs only once

    const fetchMenuData = () => {
      axios
        .get(`${process.env.REACT_APP_API_URL}/getHierarchyData`)
        .then(response => {
          const modifiedResponse = response.data.map(item => ({
            ...item,
            key: item.uuid,
          }));
          setDepartmentData(modifiedResponse);
          setLoading(false); // Set loading to false directly
        })
        .catch(error => {
          console.error(error.response.data.msg);
          // message.error(error.response.data.msg);
          setError(error.response.data.msg);
          setTimeout(function() {
            setError();
          }, 3000);
        });
    };
  
    return (
      <div className="departWrapper">
         {error && <div className='errorApi'>{error}</div>}
        <h2>Departments List</h2>
           <div className="cardsWrapper">
            {departmentData && (userRole == 'admin') ? departmentData.map((cards) =>(
              <NavLink to={`/product/?d=${cards.uuid}`}>
                 <Card
                 style={{
                     width: 250,
                     marginTop: 16,
                 }}
                 actions={[
                  <Tooltip title="visit departments">
                    <NavLink to={`/product/?d=${cards.uuid}`}><EyeOutlined key={cards.uuid}/></NavLink>
                  </Tooltip>
                 ]}
                 key={cards.key}
             >   
              
                 <Skeleton loading={loading} avatar active>
                 <Meta
  avatar={<FolderViewOutlined />}
  description={<span><strong>Department:</strong> <strong><em>{cards.name}</em></strong> <br/><strong>Total Sub-Dept:</strong> {cards.subdepartments.length - 1}</span>}
/>

                 </Skeleton>
                
             </Card>
             </NavLink>
            )) : null}

            {userDept && (userRole == 'user') ? 
            userDept.map((cards) =>(
              <NavLink to={`/product/?d=${cards.uuid}`}>
                 <Card
                 style={{
                     width: 250,
                     marginTop: 16,
                 }}
                 actions={[
                     <NavLink to={`/product/?d=${cards.uuid}`}><EyeOutlined key={cards.uuid} /></NavLink>
                 ]}
                 key={cards.key}
             >
                 <Skeleton loading={loading} avatar active>
                     <Meta
                         avatar={<FolderViewOutlined />}
                        //  title={cards.products.length ? cards.products.length : '0'}
                         description={<span><strong>Department:</strong> <strong><em>{cards.name}</em></strong></span>}
                     />
                 </Skeleton>
             </Card>
             </NavLink>
            ))  :null}
               
               
            </div>
      </div>
    )
  }
  
  export default Departments